enum ServiceItemMeasureUnit {
    Piece = 1
}

export default ServiceItemMeasureUnit;